/* eslint-disable max-len */
import React from 'react';
import { useHistory, useParams } from 'react-router-dom';

import logo from 'presentation/images/logo.svg';

import { useCourse } from 'presentation/hooks/courses';

import { ProgressBox } from 'presentation/components/progress';
import { ToroLearnIcon } from 'presentation/components/icon';
import { ToroLearnButton } from 'presentation/components/button';

import { IParams } from 'presentation/entities/params.entity';

import './styles.scss';
import { usePlaylist } from 'presentation/hooks/playlist';

export const ToroLearnHeader = (): JSX.Element => {
    const { course } = useCourse();
    const { replace } = useHistory();
    const { setSideBarActive } = usePlaylist();
    const { moduleId, idOrSlug } = useParams<IParams>();

    if (!course) return <span></span>;

    return (
        <header className={`bg-dark-toro ${moduleId && 'fixed-top'}`}>
            <div className="header-container py-1 px-5">
                <div className="logo-container">
                    {moduleId && (
                        <ToroLearnButton
                            onClick={() => {
                                replace(`/${idOrSlug}`);
                            }}
                            btnType="btn-link p-0 mr-3"
                            btnSize="btn-sm"
                        >
                            <ToroLearnIcon size={18} icon="keyboard-arrow-left" fill="white" />
                        </ToroLearnButton>
                    )}
                    <ToroLearnButton btnSize="btn-lg" btnType="btn" onClick={() => {
                        if (moduleId) return replace(`/${idOrSlug}`);
                        if (window.location.hostname !== 'localhost') window.location.href = '/';
                    }}>
                        <img loading="lazy" src={logo} alt="Toro" className="img-fluid" />
                    </ToroLearnButton>
                    {moduleId && <p className="mb-0">{course.name}</p>}
                </div>

                <div className="progress-container">
                    <ProgressBox />
                    <ToroLearnButton icon="playlist" btnSize="btn-lg" btnType="btn" onClick={() => setSideBarActive(true)} />
                </div>
            </div>
        </header>
    );
};
